module.exports = {
      id: "android-usage",
      viewBox: "0 0 114 35",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#android",
      toString: function () {
        return this.url;
      }
    }